import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { RouterOutlet } from '@angular/router';
import { Header } from './components/header/header';

@Component({
  selector: 'vx-uidcheck-root',
  imports: [Header, RouterOutlet, Header],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.html',
})
export class App {
  authService = inject(AuthService);
}
